var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      attrs: { novalidate: "", disabled: _vm.disabled },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "headline" }, [
            _vm._v(_vm._s(_vm.title)),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-container",
                [
                  _c("InputTitleSlug", {
                    attrs: {
                      "is-loading": _vm.loading,
                      title: _vm.fields.name,
                      "title-error": _vm.validationErrors.name,
                      slug: _vm.fields.slug,
                      "slug-error": _vm.validationErrors.slug,
                      isSlugEnabled: _vm.isNew,
                    },
                    on: {
                      "change:title": function ($event) {
                        _vm.fields.name = $event
                      },
                      "change:slug": function ($event) {
                        _vm.fields.slug = $event
                      },
                      "input:slug": _vm.$v.fields.slug.$touch,
                    },
                  }),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("SeoSettings", {
                            attrs: {
                              loading: _vm.disabled || _vm.loading,
                              data: _vm.data,
                            },
                            on: {
                              "on-input-seo": function ($event) {
                                _vm.fields = Object.assign(
                                  {},
                                  _vm.fields,
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      !_vm.isShowCheckboxForKiosk
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("span", [_vm._v("Для киосков")]),
                              _c("v-checkbox", {
                                attrs: {
                                  "hide-details": "",
                                  dense: "",
                                  loading: _vm.loading,
                                },
                                model: {
                                  value: _vm.fields.forKiosks,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.fields, "forKiosks", $$v)
                                  },
                                  expression: "fields.forKiosks",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      !!_vm.infoCategories && _vm.data
                        ? _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("span", [_vm._v("Родительская категория")]),
                              _c("v-select", {
                                ref: "selectParentCategory",
                                attrs: {
                                  outlined: "",
                                  "item-value": "id",
                                  "item-text": "name",
                                  clearable: "",
                                  items: _vm.infoCategories.filter(
                                    (category) =>
                                      category.id !== _vm.data.id &&
                                      category.parentId === null
                                  ),
                                  disabled: _vm.disabled,
                                  loading: _vm.loading,
                                },
                                model: {
                                  value: _vm.fields.parentCategoryId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.fields,
                                      "parentCategoryId",
                                      $$v
                                    )
                                  },
                                  expression: "fields.parentCategoryId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey--text" }, [
                            _vm._v(" Локализация "),
                          ]),
                          _c("v-select", {
                            attrs: {
                              outlined: "",
                              "item-value": "value",
                              "item-text": "title",
                              "hide-details": "",
                              dense: "",
                              items: _vm.$options.contentLocales,
                              disabled: _vm.disabled,
                              loading: _vm.loading,
                              value: _vm.language,
                            },
                            on: { change: _vm.updateLocaleHandler },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("span", { staticClass: "grey--text" }, [
                            _vm._v(" Сортировка "),
                          ]),
                          _c("v-text-field", {
                            attrs: {
                              outlined: "",
                              dense: "",
                              loading: _vm.loading,
                              disabled: _vm.disabled,
                              value: _vm.fields.sortOrder,
                            },
                            on: {
                              change: function ($event) {
                                _vm.fields.sortOrder = Number($event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "mt-auto" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    block: "",
                    color: "success darken-2",
                    type: "submit",
                    disabled: _vm.disabled,
                    loading: _vm.loading,
                  },
                },
                [_vm._v(" " + _vm._s(!!_vm.id ? "Создать" : "Сохранить") + " ")]
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "mt-auto" },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    width: "100%",
                    type: "button",
                    text: "",
                    color: "grey darken-1",
                    disabled: _vm.disabled,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel")
                    },
                  },
                },
                [_vm._v(" Отмена ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }